import { type FC } from 'react';
import Select from 'react-select';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { type TimelineDate, TimelineDateFormat } from '@editor2/types/pageElements';
import { timelineDateToDate } from './helpers';

interface Props {
	date_format: TimelineDateFormat;
	onFormatChange: (_) => void;
	date: TimelineDate;
	onDateChange: (_) => void;
}

const DatePickerBlock: FC<Props> = (props) => {
	const { date_format, onFormatChange, date, onDateChange } = props;

	const getFormatTypeOptions = () => {
		const unselectOption = { label: 'None', value: '' };
		const formatOptions = Object.keys(TimelineDateFormat).map((format) => ({
			label: format,
			value: TimelineDateFormat[format]
		}));

		return [...formatOptions, unselectOption];
	};

	const formatSelectOptions = getFormatTypeOptions();

	const getOptionByValue = (value) => {
		return formatSelectOptions.find((option) => option.value === value);
	};

	return (
		<div className="wrapBlock">
			<Select
				className="dateFormatSelect"
				value={getOptionByValue(date_format)}
				onChange={(option) => onFormatChange(option.value)}
				options={formatSelectOptions}
			/>

			{date_format && (
				<div className="datePickerWrapper">
					<DatePicker
						className="datePicker"
						dateFormat={date_format}
						selected={date ? timelineDateToDate(date) : new Date()}
						onChange={(date) => onDateChange(date)}
						showTimeInput={date_format === TimelineDateFormat['Full date and time']}
						showMonthYearPicker={date_format === TimelineDateFormat['Year and month']}
						showMonthDropdown={date_format !== TimelineDateFormat['Year']}
						showYearPicker={date_format === TimelineDateFormat.Year}
					/>
				</div>
			)}
		</div>
	);
};

export default DatePickerBlock;
